import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEye } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import { connect, useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import toastr from "toastr";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { ACTIVE_MODULE } from "app/_constants/constant";

import {
  deleteIncidentDetails,
  getMyIncidents,
} from "app/_services/ehs/ehsIncidentServices";
import {
  contractorDesignationLabel,
  contractorDropdownLabel,
  employeeDesignationLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
  fullNameLabel,
  paginationOptionsObj,
} from "app/_helpers/helper";
import {
  CURRENT_SEVERITY,
  INCIDENT_STATUS_VIEW,
  getIncidentSeverityClass,
  getIncidentStatusClass,
  incidentStatuses,
  incidentTypes,
  severities,
  staffType,
} from "./CONSTANTS";
import TableExport from "app/views/custom/components/Export/TableExport";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
// import { getAllWorkAreas } from "app/_services/ehs/ehsServices";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { filterActionAdd } from "../TrainingManagement/Assign/ReducerForAssign";
import paginationFactory from "react-bootstrap-table2-paginator";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const initialFilter = {
  departmentId: "",
  siteId: "",
  workAreaId: "",
  severity: "",
  severityPostReview: "",
  type: "",
  incidentStatus: "All",
};

const { SearchBar } = Search;

const MyIncidents = ({
  match: {
    params: { siteId },
  },
  user,
}) => {
  const ehsPermissions = JSON.parse(user.ehsPermissions || "{}");
  const filterStatus = useSelector((state) => state.filterReducerTraining);
  const dispatchFunction = useDispatch();
  const [incidents, setIncidents] = useState([]);

  const [filter, setFilter] = useState(
    filterStatus?.myIncident?.incidentStatus
      ? { ...filterStatus?.myIncident }
      : { ...initialFilter }
  );
  const [workAreas, setWorkAreas] = useState([]);
  const [sites, setSites] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [incidentsTable, setIncidentsTable] = useState([]);
  const [searchFilter, setSearchFilter] = useState();
  const [loading, setLoading] = useState(true);

  const onChange = ({ target: { name, value } }) =>
    setFilter((prev) => ({ ...prev, [name]: value }));
  const resetFilter = () => setFilter({ ...initialFilter });

  const onSearchFilter = (props) => {
    let value = props?.searchProps?.searchText;
    if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
  };

  useEffect(() => {
    dispatchFunction(filterActionAdd({ myIncidentSearch: searchFilter }));
  }, [searchFilter]);

  useEffect(() => {
    dispatchFunction(filterActionAdd({ myIncident: filter }));
  }, [filter]);

  const deleteIncident = (id) => {
    confirmAlert({
      title: "Delete Incident Details.",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteIncidentDetails(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.success("Deleted successfully.");
            setIncidents(incidents.filter((inc) => inc.id !== id));
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getMyIncidents(siteId ? `filter[siteId]=${siteId}` : "");

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }

        setIncidents(
          response.data.map((inc, idx) => {
            // if (inc.incidentStatus === "Draft" && !!inc.isBack) {
            //   return {
            //     ...inc,
            //     sid: idx + 1,
            //     incidentStatus: "Returned",
            //   };
            // }

            const severity = CURRENT_SEVERITY(inc);
            return {
              ...inc,
              sid: idx + 1,
              formattedType: incidentTypes[inc?.type],
              formattedIncidentDate: DDMMYYYYFormat(inc?.incidentDate),
              formattedReportedBy:
                inc?.staffType === "employee"
                  ? `${fullNameLabel(inc?.staffData)}`
                  : inc?.staffType === "contractor"
                  ? `${fullNameLabel(inc?.staffData)}`
                  : inc?.otherStaffName,
              formattedDesignation:
                inc?.staffType === "employee"
                  ? `${employeeDesignationLabel(inc?.staffData)}`
                  : inc?.staffType === "contractor"
                  ? `${contractorDesignationLabel(inc?.staffData)}`
                  : "NA",
              formattedSeverity: (
                <div className={getIncidentSeverityClass(severity)}>
                  {severities[severity]}
                </div>
              ),
              formattedIncidentStatus: INCIDENT_STATUS_VIEW(
                inc?.incidentStatus,
                inc?.investigationDetails?.reverted,
                inc?.isBack,
                inc
              ),
              formattedStaffType: staffType[inc?.staffType],
              createdAtView: DDMMYYYYHHMMAFormat(inc?.createdAt),
            };
          })
        );

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };

    fetchData();
    // getMyIncidents(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   setIncidents(
    //     response.data.map((inc, idx) => {
    //       // if (inc.incidentStatus === "Draft" && !!inc.isBack) {
    //       //   return {
    //       //     ...inc,
    //       //     sid: idx + 1,
    //       //     incidentStatus: "Returned",
    //       //   };
    //       // }

    //       const severity = CURRENT_SEVERITY(inc);
    //       return {
    //         ...inc,
    //         sid: idx + 1,
    //         formattedType: incidentTypes[inc?.type],
    //         formattedIncidentDate: DDMMYYYYFormat(inc?.incidentDate),
    //         formattedReportedBy:
    //           inc?.staffType === "employee"
    //             ? `${employeeDropdownLabel(inc?.staffData)}`
    //             : inc?.staffType === "contractor"
    //             ? `${contractorDropdownLabel(inc?.staffData)}`
    //             : inc?.otherStaffName,
    //         formattedSeverity: (
    //           <div className={getIncidentSeverityClass(severity)}>
    //             {severities[severity]}
    //           </div>
    //         ),
    //         formattedIncidentStatus: INCIDENT_STATUS_VIEW(
    //           inc?.incidentStatus,
    //           inc?.investigationDetails?.reverted,
    //           inc?.isBack,
    //           inc
    //         ),
    //         formattedStaffType: staffType[inc?.staffType],
    //         createdAtView: DDMMYYYYHHMMAFormat(inc?.createdAt),
    //       };
    //     })
    //   );
    // });
  }, [siteId]);

  useEffect(() => {
    setIncidentsTable(
      incidents.filter((data) => {
        if (filter.workAreaId && +data.areaId !== +filter.workAreaId) return false;
        if (filter.siteId && +data.siteId !== +filter.siteId) return false;
        if (filter.departmentId && +data.departmentId !== +filter.departmentId)
          return false;

        if (filter.type && data.type !== filter.type) return false;
        if (filter.severity && data.severity !== filter.severity) return false;
        if (
          filter.severityPostReview &&
          data.severityPostReview !== filter.severityPostReview
        )
          return false;
        if (
          filter.incidentStatus !== "All" &&
          data.incidentStatus !== filter.incidentStatus
        )
          return false;

        return true;
      })
    );
  }, [filter, incidents]);

  useEffect(() => {
    DepartmentService.getDepartment().then((response) => {
      if (!response?.data) return;

      setDepartments(response.data.departments);
    });
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;

      setWorkAreas(response.data);
    });
    getAllSites().then((response) => {
      if (!response?.data) return;

      setSites(response.data);
    });
  }, []);

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },

    {
      dataField: "incidentId",
      text: "Incident Id",
      sort: true,
      formatter: (incidentId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={`${
              siteId ? `/sites/${siteId}` : ""
            }/health-safety-and-environment/incident-management/report/view/${row.id}`}
          >
            {incidentId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "site.siteId",
      text: "Location Code",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span title={row?.site ? row?.site?.name : ""} className="icons text-cyanBlue">
            {cell}
          </span>
        );
      },
    },
    {
      dataField: "site.name",
      text: "Location Name",
      sort: true,
    },
    {
      dataField: "formattedType",
      text: "Incident Type",
      sort: true,
    },
    {
      dataField: "formattedIncidentDate",
      text: "Incident Date",
      sort: true,
    },
    {
      dataField: "generalReasons",
      text: "General-Info Reasons",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "formattedReportedBy",
      text: "Reported By",
      sort: true,
    },
    {
      dataField: "staffData.email",
      text: "Email ID",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "staffData.employeeId",
      text: "Emp ID",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "staffData.designation",
      text: "Designation",
      sort: true,
      isExcelOnly: true,
    },
    {
      dataField: "formattedDesignation",
      text: "Designation",
      sort: true,
      isTableOnly: true,
    },
    {
      dataField: "formattedSeverity",
      text: "Severity",
      sort: true,
    },
    {
      dataField: "area.name",
      text: "Area",
      sort: true,
    },

    {
      dataField: "department.name",
      text: "Department",
      sort: true,
    },
    {
      dataField: "formattedIncidentStatus",
      text: "Status",
      sort: true,
    },
    {
      dataField: "shift",
      text: "Shift",
      sort: true,
    },
    {
      dataField: "formattedStaffType",
      text: "Staff Type",
      sort: true,
    },
    {
      dataField: "createdAtView",
      text: "Time Stamp",
      sort: true,
    },
    {
      dataField: "create",
      text: "Action",
      formatter: (_rowContent, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">View</Tooltip>}
            >
              <Link
                className="icons text-cyanBlue"
                to={`${
                  siteId ? `/sites/${siteId}` : ""
                }/health-safety-and-environment/incident-management/report/view/${
                  row.id
                }`}
              >
                <FiEye />
              </Link>
            </OverlayTrigger>
            {row.incidentStatus === incidentStatuses.draft && (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                >
                  <Link
                    className="icons text-cyanBlue"
                    to={`${
                      siteId ? `/sites/${siteId}` : ""
                    }/health-safety-and-environment/incident-management/report/edit/${
                      row.id
                    }`}
                  >
                    <FiEdit3 />
                  </Link>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                >
                  <a
                    href
                    className="icons pointer text-danger"
                    onClick={() => deleteIncident(row.id)}
                  >
                    <FaRegTrashAlt />
                  </a>
                </OverlayTrigger>
              </>
            )}
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/incident-management",
          },
          {
            name: "My Incidents",
          },
        ]}
        module={ACTIVE_MODULE.incident}
      />
      <div className="card p-3">
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-1">My Incidents</h3>
          <BackBtn
            url={
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/incident-management"
            }
          />
        </div>

        {/* <Row
          className="searchIncident"
          style={{ border: "0", paddingTop: "0" }}
        >
          <Col lg={4}>
            <div className="form-group">
              <label>Area Of Operation</label>
             
              <SimpleSelect
                name="workAreaId"
                value={filter.workAreaId}
                onChange={onChange}
                className="form-control"
                id="id"
                label="name"
                options={workAreas}
                init="Select"
              ></SimpleSelect>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>Severity</label>
             

              <SimpleSelect
                name="severity"
                value={filter.severity}
                onChange={onChange}
                className="form-control"
                options={Object.keys(severities)}
                object={severities}
              ></SimpleSelect>
            </div>
          </Col>

          <Col lg={4}>
            <div className="form-group">
              <label>Incident Type</label>
             

              <SimpleSelect
                name="type"
                value={filter.type}
                onChange={onChange}
                className="form-control"
                options={Object.keys(incidentTypes)}
                object={incidentTypes}
              ></SimpleSelect>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>Department</label>
              

              <SimpleSelect
                name="departmentId"
                value={filter.departmentId}
                onChange={onChange}
                className="form-control"
                id="id"
                label="name"
                options={departments}
                init="Select"
              ></SimpleSelect>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-group">
              <label>Site Name</label>
              

              <SimpleSelect
                name="siteId"
                value={filter.siteId}
                onChange={onChange}
                className="form-control"
                id="id"
                label="name"
                options={sites}
                init="Select"
              ></SimpleSelect>
            </div>
          </Col>
        </Row>

        <div className="mt-2 text-center filterFormDivider">
          <span className="btn btn-secondary mx-2" onClick={resetFilter}>
            Reset
          </span>
        </div> */}

        {/* <ToolkitProvider
          striped
          keyField="id"
          data={incidentsTable}
          columns={sortableColumn}
          search={{
            defaultSearch: filterStatus?.myIncidentSearch,
          }}
        >
          {(props) => (
            <>
              {onSearchFilter(props)}
              <div className="d-flex align-items-center justify-content-between pb-3">
                <SearchBar {...props.searchProps} className="mb-0" />
                <div className="btn-toolbar">
                  {(!ehsPermissions.restrictIncidentReporting ||
                    +user.role?.roleLable === 1 ||
                    +user.role?.roleLable === 2) && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Create Incident</Tooltip>}
                    >
                      <Link
                        className="icons btn-icon font-20 text-cyanBlue"
                        to={
                          (siteId ? `/sites/${siteId}` : "") +
                          "/health-safety-and-environment/incident-management/report/add"
                        }
                      >
                        <FiPlusCircle />
                      </Link>
                    </OverlayTrigger>
                  )}
                  <TableExport
                    tableName={"CompleteOwnerPaymentHistory"}
                    dataColumn={sortableColumn}
                    renderData={incidents}
                    searchText={props.searchProps.searchText}
                  ></TableExport>
                </div>
              </div>
              <div className="material-master-table incidentTable">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4
                  noDataIndication={"Table is empty"}
                  pagination={paginationFactory({
                    ...paginationOptionsObj,
                    totalSize: Array.isArray(incidentsTable) ? incidentsTable.length : 0,
                  })}
                />
              </div>
            </>
          )}
        </ToolkitProvider> */}

        {!loading ? (
          <SearchBootstrapTable
            searchKey={"myIncidentsImDesktopSearch"}
            data={incidentsTable}
            columns={sortableColumn}
            tableKey="myIncidentsIm"
            defaultHideColumn={["reportedBy", "site.siteId"]}
            // tableBeforeSearch={() =>
            //   showFilter ? (
            //     <IncidentFilters
            //       tableKey="myApprovalActionIM"
            //       fields={incidentFilterFields}
            //       setForm={setFilterForm}
            //       form={filterForm}
            //       onChange={onChangeFilter}
            //       onReset={onReset}
            //     />
            //   ) : (
            //     <></>
            //   )
            // }
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(MyIncidents);
